// Those acting on behalf of the company, managers and people team members
export default {
  newHireJourneys: {
    pending: {
      index: "/new-hires/pending",
      show: "/new-hires/:id/pending/:step",
    },
    completed: {
      index: "/new-hires/completed",
    },
    index: "/new-hires",
    show: "/new-hires/:id",
    tabs: {
      tasks: {
        base: "/new-hires/:id/tasks",
      },
      communications: {
        base: "/new-hires/:id/communications",
      },
      meetings: {
        base: "/new-hires/:id/meetings",
      },
      fields: {
        base: "/new-hires/:id/fields",
      },
      paths: {
        base: "/new-hires/:id/paths",
      },
      activityFeed: {
        base: "/new-hires/:id/activity-feed",
      },
    },
    overview: "/new-hires/overview",
  },
  newHires: {
    show: "/new-hires/:id",
    showAll: "/new-hires/:id/*",
  },
};
